import React from 'react';
import { Redirect } from 'react-router-dom';
import './styles/index.less';
import LoginPageContent from 'src/containers/Login/LoginPageContent';
import { useAuth } from 'react-oidc-context';
function LoginPage() {
    const { user, isLoading, isAuthenticated } = useAuth();
    if (user && !isLoading && isAuthenticated) {
        return React.createElement(Redirect, { to: "/" });
    }
    return (React.createElement("div", { style: {
            height: '100%',
            width: '100%',
            flexGrow: 1,
            overflow: 'hidden',
            position: 'relative'
        } },
        React.createElement(LoginPageContent, null)));
}
export default LoginPage;
